export const Logo3D = ({ size = 'md', showText = false }) => {
  const iconSizes = {
    sm: 'w-10 h-10',
    md: 'w-12 h-12',
    lg: 'w-14 h-14',
    xl: 'w-20 h-20'
  };

  const textSizes = {
    sm: 'text-xl',
    md: 'text-2xl',
    lg: 'text-3xl',
    xl: 'text-4xl'
  };

  return (
    <div className="flex flex-col items-center gap-2">
      {/* Modern Premium OM Symbol Icon - Using Image */}
      <div 
        className={`${iconSizes[size]} rounded-2xl overflow-hidden shadow-lg`}
        style={{ 
          boxShadow: '0 4px 14px rgba(255, 102, 0, 0.25)'
        }}
      >
        <img 
          src="/dharmbook-logo.png" 
          alt="DharmBook"
          className="w-full h-full object-cover"
        />
      </div>
      
      {/* Show text only when explicitly requested (like on auth page) */}
      {showText && (
        <>
          <h1 
            className={`${textSizes[size]}`}
            style={{ 
              fontFamily: "'Yatra One', serif",
              color: '#EA580C',
              letterSpacing: '0.01em'
            }}
          >
            DharmBook
          </h1>
          <p 
            className="text-sm font-medium" 
            style={{ 
              fontFamily: '"Noto Sans Devanagari", serif',
              color: '#8B4513',
              letterSpacing: '0.05em'
            }}
          >
            धर्मो रक्षति रक्षितः
          </p>
        </>
      )}
    </div>
  );
};

export default Logo3D;
